import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import type { EnrichedProfitabilityPeriod } from "@/profitability/types";
export const requestedCol: ColumnDef<EnrichedProfitabilityPeriod> = {
  id: "created_at",
  header: "Requested",
  accessorFn: (row) => row.created_at,
  meta: { size: "200px" },
  // Who asked only matters next to when, and at most businesses it is the
  // same person every time, so it rides along rather than taking a column.
  cell: ({ row }) => (
    <Stack gap="none">
      <span className="text-tertiary-text">
        {row.original.display.requestedAt}
      </span>
      {row.original.display.completedAt && (
        <span className="text-xs text-tertiary-text">
          Completed {row.original.display.completedAt}
        </span>
      )}
      <span className="text-xs text-tertiary-text">
        {row.original.requester.full_name}
      </span>
    </Stack>
  ),
};
